import React, { useState } from "react";
import "./Certificates.scss";
import { Level, Certificate, CourseData } from "../ProgressDetailsInterfaces";
import DialogComponent from "../../../shared/DialogComponent/DialogComponent";
import translate from "../../../../i18n/translate";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { fetchCertificateFromURL } from "./utils";


interface CertificateProps {
  data: Certificate;
  activeLevel: Level;
  certificateData: CourseData;
}

const CertificatesBlock = (props: CertificateProps) => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);

  const [downloadIconLoader, setDownloadIconLoader] = useState<boolean>(false);

  const downloadCertificate = () => {
    setDownloadIconLoader(true);
    fetchCertificateFromURL(dispatch, setDownloadIconLoader, props)
  }

  return (
    <>
      <div onKeyDown={() => {}} data-testid="certificate" onClick={() => props.data.hasCertificate ? downloadCertificate() : setOpenDialog(true)} className="certificate">
        <div className="certificate-image">
          <img src={props.data.hasCertificate ? "../../../images/Certificate/certificate-thumbnail-common.svg" : "../../../images/Certificate/certificate-placeholder.svg"} alt="certificate" />
        </div>
        {downloadIconLoader ? <div data-testid="certificate-loader" className="certificate-loader">
          <CircularProgress size={16} color="primary" />
        </div> : <div className="certificate-lock">
          <img src={props.data.hasCertificate ?
            "../../../images/Certificate/certificate-download-icon.svg" : "../../../images/cert-badge-lock.svg"
          }
          alt="certificate"
          />
        </div>}
      </div>
      {openDialog && (
        <DialogComponent
          data-testid="dialog-component"
          openDialog={openDialog}
          title={""}
          handleClose={() => setOpenDialog(false)}
        >
          <h6>{translate("progress_overall_card_title_certificate")}:</h6>
          <p>{translate("progress_badge_dialog_box_title")}</p>
          {props.certificateData.productId !== "25" && (
            <>
              <h6>{translate("progress_overall_card_title_badge")}:</h6>
              <ul>
                <li>{translate("progress_badge_dialog_box_golden")}</li>
                <li>{translate("progress_badge_dialog_box_silver")}</li>
                <li>{translate("progress_badge_dialog_box_bronze")}</li>
              </ul>
            </>
          )}
          <p>
            {(props.certificateData.productId === "21" ||
              props.certificateData.productId === "22" ||
              props.certificateData.productId === "23" ||
              props.certificateData.productId === "24") && (
                <>*{translate("progerss_badge_dailog_box_digitalActivities")}.</>
              )}
            {(props.certificateData.productId == "20" ||
              props.certificateData.productId == "18" ||
              props.certificateData.productId == "26" ||
              props.certificateData.productId == "27" ||
              props.certificateData.productId == "28" ||
              props.certificateData.productId == "29") && <>*{translate("progress_badge_dailog_box_liveSessions")}.</>}
            {props.certificateData.productId == "25" && <>{translate("progress_elevate_dialog_box_liveSessions")}.</>}
          </p>
        </DialogComponent>
      )}
    </>
  );
};

export default CertificatesBlock;